<template>
  <WhiteTable
        :showHeader="showHeader"
        :compact="compact"
        :columns="[
          { text: '', key: 'icon', width: 20 },
          {
            text: $t('balance_table.col_date'),
            width: 120,
            key: 'created_at',
            format: 'date',
          },
          {
            text: $t('balance_table.col_time'),
            width: 120,
            key: 'created_at',
            format: 'time',
          },
          {
            text: $t('balance_table.col_category'),
            width: 200,
            renderer: (r) => $t('balance_table.categories.' + r.category),
          },
          { text: $t('balance_table.col_description'), key: 'description' },
          {
            text: $t('balance_table.col_amount'),
            key: 'amount'
          },
          {
            text: $t('balance_table.col_balance'),
            key: 'balance',
            format: 'suffix',
            suffix: '$',
            width: 120,
          },
        ]"
        :rows="transactions"
      >
        <template #col-icon="slotProps">
          <BaseIcon
            :icon="slotProps.rowItem.amount > 0 ? 'download' : 'upload'"
            :class="
              slotProps.rowItem.amount > 0 ? 'green-5-color' : 'red-4-color'
            "
            size="sm"
          />
        </template>

        <template #col-amount="slotProps">
            <span :class="slotProps.rowItem.amount > 0 ? 'green-5-color' : 'red-4-color'">
                {{ slotProps.rowItem.amount.toFixed(3) }} $
            </span>
        </template>

        <template #col-balance="slotProps">
            {{ slotProps.rowItem.balance.toFixed(3) }} $
        </template>

        <template #col-description="slotProps">
          <span v-if="slotProps.rowItem.category == 'sms'">
            {{
              $t(
                "balance_table.sms_types." +
                  slotProps.rowItem.metadata.sms_source_type
              )
            }}
          </span>
          <span v-if="slotProps.rowItem.category == 'balance_topup'">
            {{ slotProps.rowItem.metadata.topup_card_mask }}
          </span>
        </template>
      </WhiteTable>
</template>

<script>
import WhiteTable from "@/components/base/WhiteTable.vue";

export default {
    props: {
        transactions: Array,
        compact: {type: Boolean, default: true}
    },
    components: {
        WhiteTable
    },
    computed: {
        currency() {
            return this.$store.state.currency;
        }
    }
}
</script>

<style>

</style>